import { type Entity, mapEntity } from '@api';
import { PriceDisplayView } from '@terminal/components/price-display-view/PriceDisplayView';
import {
  mapEntityToPriceEntity,
  useLivePrice,
} from '@terminal/hooks/use-live-price';
import { usePreliminaryPrice } from '@terminal/react-query-hooks/prices/usePreliminaryPrice';
import { useSnakeMeta } from '@terminal/react-query-hooks/snakes/useSnake';
import { getEntityPriceVenue } from '@terminal/services/price/price-service';
import { useLegendPriceHover } from '@terminal/views/turbo-chart/hooks/use-legend-price-hover/useLegendPriceHover';
import { getPriceData } from '@terminal/widgets/asset-overview-widget/utils/asset-box/asset-box-helpers';

interface EntityLivePriceProps {
  entity: Entity;
}

export const EntityLivePrice = ({ entity }: EntityLivePriceProps) => {
  const priceHover = useLegendPriceHover({
    elementRef: {
      current: document,
    },
    enabled: false,
  });

  const mappedEntity = mapEntity(entity);

  const { data: snakeMeta } = useSnakeMeta(entity?.default_snake);

  const { data: preliminaryPrice } = usePreliminaryPrice(
    entity.subscribable_ticker ?? '',
    getEntityPriceVenue(entity)
  );

  const hoverData = priceHover?.panes[0].data[0];
  const priceEntities = mapEntityToPriceEntity(entity, snakeMeta);
  const livePriceData = useLivePrice(priceEntities);
  const livePriceInfo = getPriceData({
    hoverData,
    livePriceData,
    entity: mappedEntity,
    ts: [],
    priceEntity: priceEntities[0],
  });

  return (
    <>
      {preliminaryPrice && (
        <PriceDisplayView
          entity={mappedEntity}
          livePriceInfo={livePriceInfo}
          preliminaryPrice={preliminaryPrice.data}
          snakeMeta={snakeMeta}
          isCondensed={false}
          isChartHovered={!!hoverData?.currentPrice}
        />
      )}
    </>
  );
};
